import {Button, Grid, Typography} from "@mui/material";
import React from "react";
import {useIntl} from "react-intl";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useLanguage} from "../LanguageContext";

const CompanyAltynRail = () => {

    const {locale, changeLocale} = useLanguage();

    // console.log(locale)

    const intl = useIntl();


    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isMd = useMediaQuery(theme.breakpoints.up('md'));

    let variant = 'h3'

    let secondVariant = 'subtitle2'

    if (isXs) {
        variant = 'h3';
        secondVariant = 'subtitle2'
    } else if (isMd) {
        variant = 'h2';
        secondVariant = 'subtitle1'
    }

    return  <Grid dir={locale === 'fa' ? 'rtl' : 'ltr'}>
        <Grid bgcolor={'rgba(255, 251, 242, 1)'} px={{xs: '18px', xxs: '27px', md: '75px', lg: '103px'}}
              pt={{xs: '145px', md: '176px'}} position="relative" zIndex={2} >

            <Grid border={'2px solid rgba(255, 191, 63, 1)'} borderRadius={'20px'} bgcolor={'white'}
                  px={{xs: '12px', xxs: '16px', md: '64px'}} pt={{xs: '24px', md: '32px'}}
                  pb={{xs: '36px', md: '64px'}} mb={{xs: '24px', md: '64px'}}>
                <Typography pb={'16px'} variant={variant} fontWeight={900} color={theme.palette.secondary.one}>
                    معرفی شرکت آلتن ریل گلستان
                </Typography>


                <Grid display={"flex"}
                      justifyContent={"center"}
                      gap={2}
                      p={{md: '10px'}}>


                    <img src={"/assets/Images/company/group/ceo2.png"} width={"300px"}/>
                    <img src={"/assets/Images/company/group/logo.png"}/>

                </Grid>

                <Typography pb={'14px'} variant={"subtitle1"} color={theme.palette.secondary.dark}>
                    شرکت آلتن ریل گلستان به عنوان یکی از شرکت های زیرمجموعه آلتن گروپ لجستیک، از سال 2006 میلادی، فعالیت خود را در حوزه ارائه خدمات فورواردری ریلی بین المللی آغاز نموده است و در حال حاضر با همکاری سایر شرکت های زیرمجموعه آلتن گروپ لجستیک، توانسته است با ارائه خدمات با کیفیت، سریع و مطمئن، در مرز ریلی استان گلستان در کشور جمهوری اسلامی ایران، کالای ذیقیمت مشتریان عزیز را به کشورهای مختلف آسیانه میانه ارسال نماید.
                </Typography>

                <Typography pb={'14px'} variant={"subtitle1"} color={theme.palette.secondary.dark}>
                    این شرکت به همراه شرکت آلتن میراث گستان، عهده دار وظایف تخصصی فورواردری ریلی آلتن گروپ لجستیک در کشور جمهوری اسلامی ایران بوده و به عنوان بهترین شرکت در این زمینه اعتماد بسیاری از مشتریان را کسب و بالاترین حجم ارسال کالای صادراتی را از مرز اینچه برون در استان گلستان را از آن خود نموده است.

                </Typography>

                <Typography pb={'14px'} variant={"subtitle1"} color={theme.palette.secondary.dark}>
                    مدیرعامل شرکت آلتن ریل گلستان، آقای رجب قزاق، از همراهی و اعتماد مشتریان صمیمانه قدردانی نموده و این اطمینان را می دهد که همواره در ارائه باکیفیت خدمات و جلب رضایت مشتری، بهترین در نوع خود باشد.

                </Typography>


                <br/>
                <Typography pb={'16px'} variant={variant} fontWeight={900} color={theme.palette.secondary.one}>
                     شرکت آلتن ریل گلستان آمادگی خود را نسبت به انجام کلیه خدمات ذیل اعلام می دارد:
                </Typography>
                <Typography pb={'14px'} variant={"subtitle1"} color={theme.palette.secondary.dark}>
                    <ul>
                        <li>معرفی تولیدکنندگان کالا و ارائه دهندگان خدمات معتبر به تجار محترم جهن عقد قراردادهای تجاری بین المللی</li>
                        <li>انجام امور لجستیکی (حمل و نقل، تخلیه و بارگیری) و امور گمرکی در کشور جمهوری اسلامی ایران و حمل کالا به کشورهای مقصد</li>
                        <li>برنامه ریزی جهت تهیه بار برای دوسر بارگیری واگن ها در مسیر آسیای میانه و ایران و افغانستان و و ارائه مشاوره های تخصصی درخصوص کاهش هزینه های حمل و نقل
                        </li>
                        <li>اعزام واگن های تخلیه شده در جمهوری ترکمنستان از طریق مرزهای ریلی "اینچه برون" و "آق ییلا" به ایران جهت بارگیری به مقصد قزاقستان
                        </li>
                        <li>اجاره زمانی انواع واگن های شما مابین کشورهای آسیای میانه، افغانستان و ایران</li>
                        <li>حمل ترانزیتی کالاها از ترکیه، آسیای جنوب شرقی، جمهوری عراق و کشورهای حاشیه خلیج فارس به کشورهای آسیای میانه و افغانستان</li>

                    </ul>
                </Typography>


                <Typography pb={'16px'} variant={variant} fontWeight={900} color={theme.palette.secondary.one}>
                    منشور اخلاقی شرکت آلتن ریل گلستان:
                </Typography>

                <Typography pb={'14px'} variant={"subtitle1"} color={theme.palette.secondary.dark}>
                    <ul>
                        <li>توجه و اعتقاد به سه ارزش اصلی: مسئولیت پذیری، تنوع خدمات و غرور
                        </li>
                        <li>استفاده از ظرفیت سایر شرکتهای زیرمجموعه آلتن گروپ و شرکای کلیدی در ارائه بهترین و کاملترین خدمات ممکن در اکوسیستم حمل و نقل بین المللی
                        </li>
                        <li>تعامل مستمر با مشتریان برای اطمینان بخشی و ارائه خدمات در بهترین کیفیت و سریعترن زمان ممکن
                        </li>
                        <li>همکاری با مشتریان در نوع و چگونگی پرداخت هزینه های خدمات به روش های مختلف و در کشورهای مختلف
                        </li>
                        <li>ارائه مشاوره تخصصی برای کاهش هزینه های حمل و نقل کالای صادراتی به مشتریان</li>
                        <li>بکارگیری ابزارهای تخصصی فناوری اطلاعات و ارتباطات برای پایش و رصد محموله های ارسالی توسط مشتریان و ارائه زمانبندی دقیق تحویل کالا در مقصد
                        </li>
                        <li>استفاده از بهترین پرسنل تخصصی در امر لجستیک و بهره برداری از بهترین ابزارهای حمل و نقل کالا با هدف به حداقل رساندن آسیبهای احتمالی به کالای صادراتی</li>
                        <li>ارائه صورتحسابهای شفاف، گویا و مستمر جهت مدیریت پرداخت های مالی فی مابین
                        </li>
                        <li>این شرکت در همراهی مجموعه آلتن گروپ، در تلاش است با ایجاد ارتباط قوی لجستیکی بین صاحبان واگن در منطقه و تجار محترم از این پتانسیل و زیرساخت به بهترین نحو استفاده نماید و با برنامه ریزی و شناسایی شرکت های دارای واگن ها و طراحی پلن برای بهینه سازی و کاهش هزینه ها در نظر دارد ضمن همکاری مستقیم با تجار و صادرکنندگان محترم در بحث واگذاری واگن و فراهم سازی محموله مناسب برای بازارهای هدف و شرکت های صاحب واگن در کشورهای منطقه، تلاش مضاعف بر بربارگیری واگن های ارسالی تخلیه شده در مناطق مستقر شده گروه آلتن و بارگشت همراه با محموله واگن به کشور مبدا را دارد. لذا از کلیه شرکتهای صاحب واگن برای ایجاد شبکه لجستیکی و تجار محترم برای تشکیل شبکه تجاری با استفاده حداکثری از پتانسیل دوطرفه دعوت به همکاری می نماید. تا ضمن کاهش هزینه های حمل و نقل، مسیر را برای افزایس سود دوجانبه نیز هموار سازد.</li>

                    </ul>

                    <Grid display={"flex"} m={{md:'10px'}}>
                        <img src={"/assets/Images/company/rail/chart.png"} border={3}/>
                    </Grid>

                    این شرکت در همراهی مجموعه آلتن گروپ، در تلاش است با ایجاد ارتباط قوی لجستیکی بین صاحبان واگن در منطقه و تجار محترم از این پتانسیل و زیرساخت به بهترین نحو استفاده نماید و با برنامه ریزی و شناسایی شرکت های دارای واگن ها و طراحی پلن برای بهینه سازی و کاهش هزینه ها در نظر دارد ضمن همکاری مستقیم با تجار و صادرکنندگان محترم در بحث واگذاری واگن و فراهم سازی محموله مناسب برای بازارهای هدف و شرکت های صاحب واگن در کشورهای منطقه، تلاش مضاعف بر بربارگیری واگن های ارسالی تخلیه شده در مناطق مستقر شده گروه آلتن و بارگشت همراه با محموله واگن به کشور مبدا را دارد. لذا از کلیه شرکتهای صاحب واگن برای ایجاد شبکه لجستیکی و تجار محترم برای تشکیل شبکه تجاری با استفاده حداکثری از پتانسیل دوطرفه دعوت به همکاری می نماید. تا ضمن کاهش هزینه های حمل و نقل، مسیر را برای افزایس سود دوجانبه نیز هموار سازد.
                </Typography>


                <hr />

                <div className="flex">

                </div>



            </Grid>
        </Grid>
    </Grid>
}

export default CompanyAltynRail;